var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topbar-metadata-container"},[_vm._t("left"),(_vm.$slots.metadata)?_c('div',{staticClass:"vertical-divider"}):_vm._e(),_c('div',{staticClass:"metadata-container"},[_vm._t("metadata")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }